import React from 'react'
import styled from 'styled-components'
import tinycolor from 'tinycolor2'
import _ from 'lodash'
import Select from 'react-select'
import Toggle from 'react-toggle'
import {
  injectIntl,
  FormattedMessage
} from 'react-intl'
import {
  Badge
} from 'reactstrap'

import apolloClient from '../../../services/ApolloClient'
import Card from '../../atoms/Card'
import gql from 'graphql-tag'

import {
  RawSelectableButton
} from '../../molecules/SelectableButton'

import AsyncSelect from 'react-select/lib/Async';

import { FETCH_BRAZIL_TERRITORY } from '../../../logic/TerritoryQueryUtils';

const ToggleWrapper = styled.label`
  display: inline-block;
  margin-right: 24px;
  margin-bottom: 24px;
`

const StyledToggleTrigger = styled(Toggle)`
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
`

const ToggleLabel = styled.span`
  display: inline-block;
  vertical-align: middle;
`

const FilterSelectContainer = styled.div`
  height: 220px;
`

const TerritorySelectionContainer = styled.div`
  &>* {
    margin-bottom: 1rem;
    margin-top: 1rem;
  }

  &>*:last-child {
    margin-bottom: 0;
  }
`

const TerritoryTypeSelect = styled(Select)`
  width: 20rem;
`

const TerritorySelect = styled(AsyncSelect)`
  width: 20rem;
`

const ButtonRow = styled.div`
  align-items: center;
  display: flex;
  padding-bottom: 8px;
  padding-top: 8px;
`

const StyledCard = styled(Card)`
  padding: 20px;

  &>* {
    margin-bottom: 8px;
  }

  &>*:last-child {
    margin-bottom: 0;
  }
`

const CounterBadge = styled(Badge)`
  margin-left: 0.4rem;
  padding: 0.25rem 0.4rem !important;
`

const Button = styled(RawSelectableButton)`
  box-shadow: 2px 2px 3px ${({ theme }) => (
    tinycolor(
      theme.colors.grayContrast
    ).darken(15).toString()
  )};
  margin-right: 12px;
  max-width: 11rem;
  padding-left: 14px !important;
  padding-right: 14px !important;

  &:last-child {
    margin-right: 0;
  }
`

const TitleContainer = styled.div`
  margin-bottom: 8px;
  margin-top: 16px;
`

const Title = styled.span`
  color: ${({ theme }) => theme.colors.text.gray};
  font-size: 1.50rem;
  font-weight: bold;
`

export const ASYNC_SELECT_BY_REGIONS_REGION = gql`
  query AsyncSelectByRegionsRegion($name: String!) {
    regionByName(name: $name) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_REGIONS_STATE = gql`
  query AsyncSelectByRegionsState($name: String!, $recgeoIds: [Int!]!) {
    statesByRecGeo(name: $name, recgeo_ids: $recgeoIds, limit: 10000, page: 1) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_REGIONS_MESOREGION = gql`
  query AsyncSelectByRegionsMesoregion($name: String!, $recgeoIds: [Int!]!) {
    mesoregionsByRecGeo(name: $name, recgeo_ids: $recgeoIds, page: 1, limit: 10000) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_REGIONS_MICROREGION = gql`
  query AsyncSelectByRegionsMicroregion($name: String!, $recgeoIds: [Int!]!) {
    microregionsByRecGeo(name: $name, recgeo_ids: $recgeoIds, page: 1, limit: 10000) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_REGIONS_CITY = gql`
  query AsyncSelectByRegionsCity($name: String!, $recgeoIds: [Int!]!) {
    citiesByRecGeo(name: $name, recgeo_ids: $recgeoIds, page: 1, limit: 10000) {
      id
      name: nome
      cd_muns
    }
  }
`

export const ASYNC_SELECT_BY_BIOMES_BIOME = gql`
  query($name: String!) {
    biomesByName(name: $name) {
      id
      name: nome      
    }
  }
`

export const ASYNC_SELECT_BY_BIOMES_CITY = gql`
  query($name: String!, $biomeIds: [Int!]!) {
    citiesByBiome(name: $name, biome_ids: $biomeIds, limit: 10000, page: 1) {
      id
      name: nome
      biomeName: bioma
    }
  }
`

export const QUERIES = {
  "regions_country" : FETCH_BRAZIL_TERRITORY,
  "regions_region" : ASYNC_SELECT_BY_REGIONS_REGION,
  "regions_state" : ASYNC_SELECT_BY_REGIONS_STATE,
  "regions_mesoregion" : ASYNC_SELECT_BY_REGIONS_MESOREGION,
  "regions_microregion": ASYNC_SELECT_BY_REGIONS_MICROREGION,
  "regions_city": ASYNC_SELECT_BY_REGIONS_CITY,
  "biomes_biome": ASYNC_SELECT_BY_BIOMES_BIOME,
  "biomes_city": ASYNC_SELECT_BY_BIOMES_CITY,
  "regions_regions" : ASYNC_SELECT_BY_REGIONS_REGION,
  "regions_states" : ASYNC_SELECT_BY_REGIONS_STATE,
  "regions_mesoregions" : ASYNC_SELECT_BY_REGIONS_MESOREGION,
  "regions_microregions": ASYNC_SELECT_BY_REGIONS_MICROREGION,
  "biomes_biomes": ASYNC_SELECT_BY_BIOMES_BIOME,
}

const territoryTypeSelected =  React.createRef();

class ResearchTerritorySelector extends React.PureComponent { 

  constructor() {
    super();

    this.state = {
      selectedType: "",
      territoryOptions: [],
      selectedTerritories: [],
      isAggregated: false,
      selectedUnaggreType: "",
      isLoading: false
    };
    this.currentSelectedTerritoryType = ""
    // Binds the Event to the Current Instance 
    this.onChangeTerritoryType = this.onChangeTerritoryType.bind(this);
    this.onChangeAggrToggle = this.onChangeAggrToggle.bind(this);
    this.onChangeTerritoriesSelection = this.onChangeTerritoriesSelection.bind(this);
    this.onChangeUnaggreSelected = this.onChangeUnaggreSelected.bind(this);
    this.setAggregated = this.setAggregated.bind(this);
  }

  generateOption(territory) {
    return {
      label: territory.name,
      value: territory
    }
  }

  setAggregated(territory) {
    const { selectedUnaggreType, selectedType } = this.state;

    return ({...territory, isAggregated: this.state.isAggregated, kind: (selectedType + "_" + selectedUnaggreType.value)});
  }

  // Executes a Search
  queryTerritories = _.debounce((filter, query, callback) => {
    apolloClient.query({
      query: QUERIES[query],
      variables: filter
    }).then(callback)
  }, 500);

  // Events
  onChangeAggrToggle(evt) {
    const { isAggregated } = this.state;
    this.setState({isAggregated: !isAggregated});
  }

  onChangeUnaggreSelected(selected) {
    this.setState({selectedUnaggreType: selected});    

    const { selectedTerritories, selectedType } = this.state;

    if(this.state.isAggregated) {
      this.props.onChangeSelectedFilter(selected.value);
      this.props.onChangeSelectedTerritoryType(selected.value);

      const onFilterChange = this.props.onTerritoryFilterSelectChange[selected.value];
      const queryKey = this.props.selectedTerritoryType + "_" + selected.value;

      this.setState({isLoading: true});

      this.queryTerritories({
        biomeIds: [],
        name: "",
        recgeoIds: [
          selectedTerritories.value.id
        ]
      }, 
      queryKey, 
      (result) => {
        let results = result.data[_.keys(result.data)[0]].map(this.setAggregated);
        onFilterChange({ results: results, key: queryKey});
        this.setState({isLoading: true});
      });
    }
  }

  onChangeTerritoriesSelection(selected) {
    this.setState({selectedTerritories: selected});
    
    if(!this.state.isAggregated) {
      this.props.onChangeSelectedTerritory(selected.value);
    } 
  }

  getLoadingOption() {
    return {
      label: this.props.intl.formatMessage({
        id: 'loading'
      }),
      value: '-'
    };
  }

  onChangeTerritoryType(selected) {
    const value = selected.value;
    this.currentSelectedTerritoryType = selected.value;
    if (selected.value == 'city') {
      this.setState({isAggregated: false});
      document.getElementById("desagregadorCheckbox").disabled = true 
    } else {
      document.getElementById("desagregadorCheckbox").disabled = false 
    }    
    this.setState({
      selectedType: value
    });

    const queryKey = this.props.selectedTerritoryType + "_" + value;
    this.setState({
      territoryOptions: [ this.getLoadingOption()   ],
      isLoading: false
    })

    this.queryTerritories({
      biomeIds: [],
      name: "",
      recgeoIds: []
    }, 
    queryKey, 
    (result) => {
      let results = result.data[_.keys(result.data)[0]].map(this.setAggregated);
      let options = _.map(results, this.generateOption);
      this.setState({
        territoryOptions: options,
        isLoading: false
      })
    });
  

    this.props.onChangeSelectedTerritoryType(value);
    this.props.onChangeSelectedFilter(value);
  }

  // Render

  getUnaggreTypeOptions() {
    let options = []
    if (this.props.selectedTerritoryType === 'regions') {

      if (this.currentSelectedTerritoryType == 'country') {

        options = [
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_region'
            }),
            value: 'region'
          },
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_state'
            }),
            value: 'states'
          },
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_mesoregion'
            }),
            value: 'mesoregion'
          },
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_microregion'
            }),
            value: 'microregion'
          },
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_city'
            }),
            value: 'city'
          }
        ]        
      }


      if (this.currentSelectedTerritoryType == 'region') {

        options = [
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_state'
            }),
            value: 'states'
          },
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_mesoregion'
            }),
            value: 'mesoregion'
          },
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_microregion'
            }),
            value: 'microregion'
          },
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_city'
            }),
            value: 'city'
          }
        ]       
      }

      if (this.currentSelectedTerritoryType == 'state') {
        options = [
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_mesoregion'
            }),
            value: 'mesoregion'
          },
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_microregion'
            }),
            value: 'microregion'
          },
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_city'
            }),
            value: 'city'
          }
        ]        
      }


      if (this.currentSelectedTerritoryType == 'mesoregion') {

        options = [
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_microregion'
            }),
            value: 'microregions'
          },
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_city'
            }),
            value: 'city'
          }
        ]        
      }

      if (this.currentSelectedTerritoryType == 'microregion') {
        options = [
          {
            label: this.props.intl.formatMessage({
              id: 'survey.territories.modal_add_territory_select_type_option_city'
            }),
            value: 'city'
          }
        ]
      }
    } else if (this.props.selectedTerritoryType === 'biomes') {
      options = [
        {
          label: this.props.intl.formatMessage({
            id: 'survey.territories.modal_add_territory_select_type_option_biome'
          }),
          value: 'biomes'
        }
      ]
    }

    return options;
  }

  getTypeOptions() {
    let options = []
    if (this.props.selectedTerritoryType === 'regions') {
      options = [
        {
          label: this.props.intl.formatMessage({
            id: 'survey.territories.modal_add_territory_select_type_option_country'
          }),
          value: 'country'
        },
        {
          label: this.props.intl.formatMessage({
            id: 'survey.territories.modal_add_territory_select_type_option_region'
          }),
          value: 'region'
        },
        {
          label: this.props.intl.formatMessage({
            id: 'survey.territories.modal_add_territory_select_type_option_state'
          }),
          value: 'state'
        },
        {
          label: this.props.intl.formatMessage({
            id: 'survey.territories.modal_add_territory_select_type_option_mesoregion'
          }),
          value: 'mesoregion'
        },
        {
          label: this.props.intl.formatMessage({
            id: 'survey.territories.modal_add_territory_select_type_option_microregion'
          }),
          value: 'microregion'
        },
        {
          label: this.props.intl.formatMessage({
            id: 'survey.territories.modal_add_territory_select_type_option_city'
          }),
          value: 'city'
        }
      ]
    } else if (this.props.selectedTerritoryType === 'biomes') {
      options = [
        {
          label: this.props.intl.formatMessage({
            id: 'survey.territories.modal_add_territory_select_type_option_biome'
          }),
          value: 'biome'
        },
        {
          label: this.props.intl.formatMessage({
            id: 'survey.territories.modal_add_territory_select_type_option_city'
          }),
          value: 'city'
        }
      ]
    }

    return options;
  }

  renderUnaggreSelector() {
    const { isAggregated, selectedUnaggreType } = this.state;

    if(isAggregated) {
          return (
                <FormattedMessage
                  id="survey.territories.modal_add_territory_select_unagreetype_placeholder"
                >
                  {(text) => {
                    let options = this.getUnaggreTypeOptions();

                    return (
                      <TerritoryTypeSelect
                        isSearchable={ false }
                        onChange={ this.onChangeUnaggreSelected }
                        options={ options }
                        placeholder={ text }
                        value={ selectedUnaggreType }
                      />
                    )
                  }}
                </FormattedMessage>
          );
    }

    return ( <div /> );
  }


  renderTerritorySelector() {
    const { territoryOptions, selectedTerritories } = this.state;

    return (
          <FormattedMessage
            id="survey.territories.modal_add_territory_select_type_placeholder"
          >
            {(text) => {
              return (
                <TerritoryTypeSelect
                  isSearchable={ true }
                  onChange={ this.onChangeTerritoriesSelection }
                  options={ territoryOptions }
                  placeholder={ text }
                  value={ selectedTerritories }
                />
              )
            }}
          </FormattedMessage>
    );
  }

  renderTypeSelector() {
        return (
          <FormattedMessage
            id="survey.territories.modal_add_territory_select_territory_placeholder"
          >
            {(text) => {
             
              let options = this.getTypeOptions();

              return (
                <TerritoryTypeSelect
                  isSearchable={ false }
                  onChange={ (value) => {                    
                    this.onChangeTerritoryType(value);
                  } }
                  options={ options }
                  placeholder={ text }
                />
              )
            }}
          </FormattedMessage>
    );
  }

  render() {
    const { isAggregated } = this.state;
    return (
      <div>
        <TitleContainer>
          <FormattedMessage
            id="survey.messages.territory_modal_search_title"
          >
            {(text) => (
              <Title>
                { text }
              </Title>
            )}
          </FormattedMessage>
        </TitleContainer>
        <TerritorySelectionContainer>
            <ToggleWrapper key='filter-aggr-toggle' >
              <StyledToggleTrigger
                id="desagregadorCheckbox"
                checked={ isAggregated }
                onChange={ this.onChangeAggrToggle }
              />
              <FormattedMessage
                    id="survey.territories.territory_modal_unaggregate"
                  >
                    {(text) => (
                      <ToggleLabel>{ text }</ToggleLabel>
                    )}
              </FormattedMessage>
            </ToggleWrapper>

              { this.renderTypeSelector() }
              { this.renderTerritorySelector() }
              { this.renderUnaggreSelector() }
        </TerritorySelectionContainer>
      </div>
    )
  }
}

export default injectIntl(ResearchTerritorySelector)



// WEBPACK FOOTER //
// ./src/components/organisms/ResearchTerritorySelector/ResearchTerritorySelector.js